'use client';

import { VerificationCodeForm } from '@prismo-io/feature-organization/forms/verification-code';
import { type ComponentProps, type FC, useCallback } from 'react';
import { useSetOrganizationMetadata } from './use-set-organization-metadata';

type FormProps = ComponentProps<typeof VerificationCodeForm>;

type Props = Omit<FormProps, 'onSubmit' | 'app'>;

export const VerificationCodeFormWrapper: FC<Props> = (props) => {
  const { trigger: setMetadata } = useSetOrganizationMetadata();

  const onSubmit: FormProps['onSubmit'] = useCallback(
    (data) => {
      setMetadata({
        ...data,
        emailIsValid: true,
      });
    },
    [setMetadata]
  );

  return (
    <VerificationCodeForm {...props} app="ONBOARDING" onSubmit={onSubmit} />
  );
};
